import React, { memo, Suspense } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({
  Component,
  authority,
  isLayout = false,
  admin = false,
  ...routerProps
}) => {
  const { token, isAdmin, authority: userAuthorities } = useSelector((state) => state?.auth);
  function routeFunc(props) {
    if (token) {
      if (userAuthorities?.includes(authority)) {
        if (admin) {
          if (isAdmin) {
            return (
              <Suspense fallback={<></>}>
                <Component {...props} />
              </Suspense>
            );
          } else {
            return <Redirect to={{ pathname: '/admin/login' }} />;
          }
        } else if (!isAdmin) {
          return (
              <Suspense fallback={<></>}>
                <Component {...props} />
              </Suspense>
          );
        } else {
          return <Redirect to={{pathname: '/login'}}/>;
        }
      }
    } else {
      return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
    }
  }

  return <Route {...routerProps} render={routeFunc} />;
};

export default memo(PrivateRoute);
